import HttpClient from './HttpClient';

interface AddressAutocompleteParams {
  freeText?: string;
  captureGroupId?: string;
  captureId?: string;
  endpoint?: string;
}

export const SA_SHORT_ADDRESS_ENDPOINT = 'shortaddress';

class AddressAutocompleteService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

   private async callSaudiShortAddress(freeText: string): Promise<any> {
    const { LANGUAGE } = CSS_CONFIG;
    const shortAddress = (freeText || '').toUpperCase();
    const endpoint = `shortaddress/${shortAddress}`;

    const headersObj: Record<string, string> = {
      'Accept-Language': `${LANGUAGE}-SA`,
    };
    const addressBaseUrl = this.getAddressApiBaseUrl();
    const finalUrl = `${addressBaseUrl}${endpoint}`;

    const response = await fetch(finalUrl, {
      method: 'GET',
      credentials: 'include',
      headers: new Headers(headersObj),
    });

    if (!response.ok) {
      throw new Error(`Short address lookup failed with status ${response.status}`);
    }

    const result = await response.json();
    return result;
  }

  private getAddressApiBaseUrl(): string {
    const cfg = CSS_CONFIG as any;
    const baseUrl = cfg.SPAREPARTAPIHOST || 'https://api.test.apo.ingka.com/';
    return baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
  }

  public async calladdressautocomplete({
    freeText,
    captureGroupId,
    captureId,
   endpoint,
  }: AddressAutocompleteParams): Promise<any> {
    if (endpoint === SA_SHORT_ADDRESS_ENDPOINT) {
      return this.callSaudiShortAddress(freeText || '');
    }
    const { COUNTRY, LANGUAGE } = CSS_CONFIG;
    const apiEndpoint = endpoint || 'address/autocomplete';
    const { error, result } = await this.http.postaddressapi(
      apiEndpoint,
      {
        country: COUNTRY,
        language: LANGUAGE,
        freeText: freeText,
        captureGroupId: captureGroupId,
        captureId: captureId,
      }
    );
    if (error) {
      throw error;
    }
    return result;
  }
}

export const addressAutocompleteService = new AddressAutocompleteService(
  new HttpClient()
);
